export const teamOptions = [
    {
        label: "Phôi",
        value: "Phôi",
        children: [
            { label: "Veneer", value: "Veneer" },
            { label: "Phôi", value: "Phôi" },
            { label: "Tấm", value: "Tấm" },
        ],
    },
    {
        label: "Tinh chế",
        value: "Tinh chế",
        children: [
            { label: "Tinh chế", value: "Tinh chế" },
            { label: "Tinh chế mẫu", value: "Tinh chế mẫu" },
            { label: "CNC", value: "CNC" },
            { label: "Khoan", value: "Khoan" },
            { label: "Cơ khí ", value: "Cơ khí " },
        ],
    },
    {
        label: "Lắp ráp",
        value: "Lắp ráp",
        children: [
            { label: "Lắp ráp 1", value: "Lắp ráp 1" },
            { label: "Lắp ráp 2", value: "Lắp ráp 2" },
            { label: "Lắp ráp 3", value: "Lắp ráp 3" },
            { label: "Lắp ráp 4", value: "Lắp ráp 4" },
            { label: "Lắp ráp 5", value: "Lắp ráp 5" },
            { label: "Lắp ráp 6", value: "Lắp ráp 6" },
            { label: "Nhám", value: "Nhám" },
        ],
    },
    {
        label: "Bán thành phẩm",
        value: "Bán thành phẩm",
        children: [
            { label: "Kho bán thành phẩm", value: "Kho bán thành phẩm" },
            { label: "Kho gia công", value: "Kho gia công" },
        ],
    },
    {
        label: "Lắp ráp - Sofa",
        value: "Lắp ráp - Sofa",
        children: [
            { label: "May", value: "May" },
            { label: "Sofa", value: "Sofa" },
        ],
    },
    {
        label: "PU",
        value: "PU",
        children: [
            { label: "PU lẻ", value: "PU lẻ" },
            { label: "Chuyền sơn", value: "Chuyền sơn" },
        ],
    },
    {
        label: "LRHT",
        value: "LRHT",
        children: [
            { label: "Dặm vá", value: "Dặm vá" },
            { label: "LRHT 1", value: "LRHT 1" },
            { label: "LRHT 2", value: "LRHT 2" },
            { label: "Báo cáo chất lượng", value: "Báo cáo chất lượng" },
        ],
    },
    {
        label: "Bao Bì",
        value: "Bao Bì",
        children: [
            { label: "Đã Giao", value: "Đã Giao" },
            { label: "Bao bì", value: "Bao bì" },
            { label: "Giao hàng", value: "Giao hàng" },
        ],
    },
];
